export default class RequestHelper {
    static buildRequest(url, method = 'POST', params = {}, headers = {}) {
        const requestData = {
            credentials: 'same-origin',
            method,
            headers,
        };

        let urlVar = url;

        if (method === 'GET' && Object.keys(params).length !== 0) {
            const esc = encodeURIComponent;
            urlVar += `?${Object.keys(params)
                .map((k) => `${esc(k)}=${esc(params[k])}`)
                .join('&')}`;
        }

        if (method === 'POST') {
            if ('Content-Type' in headers && headers['Content-Type'] === 'application/json') {
                requestData.body = JSON.stringify(params);
            } else {
                requestData.body = params;
            }
        }

        return new Request(url, requestData);
    }

    static async send(request) {
        const response = await fetch(request);
        return response.json();
    }

    // eslint-disable-next-line class-methods-use-this
    async makeAuthenticatedRequest(url, method = 'POST', params = {}, isJson = true) {
        const parsedUrl = new URL(url, WEBROOT);
        const headers = {};

        if (isJson) {
            headers['Content-Type'] = 'application/json';
        }

        // We have no nonce for the request, so try to find one in the Electro.requestNonces object
        if (!parsedUrl.searchParams.has('_wpnonce')) {
            headers['X-WP-Nonce'] = FreshStep.wpRestNonce;
        }

        const request = RequestHelper.buildRequest(url, method, params, headers);
        const response = await fetch(request);
        if ('X-WP-Nonce' in response.headers) {
            FreshStep.wpRestNonce = response.headers['X-WP-Nonce'];
        }

        return response.json();
    }

    async makeRequest(url, method = 'POST', params = {}, isJson = true) {
        let headers = {};
        let paramsVar = params;

        if (isJson === true) {
            headers = {
                'Content-Type': 'application/json',
            };
        } else {
            paramsVar = this.convertObjectToFormData(params);
        }
        const request = RequestHelper.buildRequest(url, method, paramsVar, headers);
        const response = await fetch(request);
        return response.json();
    }

    convertObjectToFormData(object, fd, parentProperty) {
        const formData = fd || new FormData();
        let key;

        // eslint-disable-next-line no-restricted-syntax
        for (const property in object) {
            if (Object.prototype.hasOwnProperty.call(object, property)) {
                if (typeof object[property] === 'undefined') {
                    // eslint-disable-next-line no-continue
                    continue;
                }

                if (parentProperty) {
                    key = `${parentProperty}[${property}]`;
                } else {
                    key = property;
                }

                if (typeof object[property] === 'object') {
                    this.convertObjectToFormData(object[property], formData, property);
                } else {
                    formData.append(key, object[property]);
                }
            }
        }

        return formData;
    }
}
